import RbacUserAssignedDataTab from '../pages/RbacUserAssignedDataTab'
import React from 'react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import TabsMui from '../../layout/TabsMui'
import RbacUserDetailTab from '../pages/RbacUserDetailTab'
import RbacUserHistoryTab from '../pages/RbacUserHistoryTab'
import {
  RBAC_USER_DETAIL_TAB_VALUE,
  RBAC_USER_ASSIGNED_DATA_TAB_VALUE,
  RBAC_USER_DETAIL_TABS,
  RBAC_USER_DETAIL_TEXTS,
  RBAC_USER_HISTORY_TAB_VALUE
} from '../pages/shared/rbacUserDetailConstants'

export default function RbacUserDetailContent({
  error,
  user,
  canManage,
  activeTab,
  historyRows,
  historyLoading,
  historyPagination,
  resending,
  onBack,
  onTabChange,
  onEditUser,
  onStatusAction,
  onResendInvitation,
  onHistoryPageChange,
  onHistoryRowsPerPageChange
}) {
  return (
    <div className="index-table">
      <Box sx={{ minWidth: 0, mb: { xs: 3, md: 6 } }}>
        {!user ? (
          <Box>
            <Typography color="error" sx={{ mb: 2 }}>
              {error || RBAC_USER_DETAIL_TEXTS.notFound}
            </Typography>
            <Button variant="outlined" onClick={onBack}>
              {RBAC_USER_DETAIL_TEXTS.backToUsersLabel}
            </Button>
          </Box>
        ) : (
          <>
            <TabsMui
              tabs={RBAC_USER_DETAIL_TABS}
              activeTab={activeTab}
              onChange={onTabChange}
              scrollable
              appearance="pill"
              filled={false}
              ariaLabel="Secciones del usuario"
            />

            <div className="tab-content-area">
              {activeTab === RBAC_USER_DETAIL_TAB_VALUE && (
                <RbacUserDetailTab
                  user={user}
                  canManage={canManage}
                  resending={resending}
                  onEditUser={onEditUser}
                  onStatusAction={onStatusAction}
                  onResendInvitation={onResendInvitation}
                />
              )}

              {activeTab === RBAC_USER_ASSIGNED_DATA_TAB_VALUE && (
                <RbacUserAssignedDataTab
                  user={user}
                  canManage={canManage}
                  onEditUser={onEditUser}
                  onStatusAction={onStatusAction}
                />
              )}

              {activeTab === RBAC_USER_HISTORY_TAB_VALUE && (
                <RbacUserHistoryTab
                  rows={historyRows}
                  loading={historyLoading}
                  pagination={historyPagination}
                  onPageChange={onHistoryPageChange}
                  onRowsPerPageChange={onHistoryRowsPerPageChange}
                />
              )}
            </div>
          </>
        )}
      </Box>
    </div>
  )
}
